export default {
    title:`Confirmation`,
    h1:`SIGNED, SEALED, DELIVERED!`,
    h3:`Your (anonymous) love letter is on its way to your crush! We’ll let you know immediately if there’s a match. In the meantime, please add CrushPledge.com to your address book, so messages don’t get lost in your spam folder.`,
    done:`Finish`
}


// WEBPACK FOOTER //
// ./assets/strings/confirmation.js